import { render, staticRenderFns } from "./LoaderSvg.vue?vue&type=template&id=79fc5378"
import script from "./LoaderSvg.vue?vue&type=script&lang=ts"
export * from "./LoaderSvg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports